import qs from 'qs'
import axios, { AxiosRequestConfig, AxiosRequestHeaders, AxiosRequestTransformer } from 'axios'
import { API_BASE_URL } from './connectionConsts'

const baseURL =
  process.env.NODE_ENV === 'production' ? `${window.location.origin}/api` : `${API_BASE_URL}/api`

const apiOrigin = new URL(baseURL, window.location.origin).origin

// In development the API is on another origin, and axios only sends the CSRF header same-origin.
const isApiRequest = (config: AxiosRequestConfig): boolean => {
  try {
    return new URL(config.url ?? '', config.baseURL ?? window.location.origin).origin === apiOrigin
  } catch {
    return false
  }
}

// axios turns a FormData body into JSON when the request says application/json.
const sendFormDataAsMultipart: AxiosRequestTransformer = (
  data: unknown,
  headers?: AxiosRequestHeaders
) => {
  if (data instanceof FormData && headers) {
    delete headers['Content-Type']
  }
  return data
}

export const apiConfig: AxiosRequestConfig = {
  withCredentials: true,
  timeout: 14400000, //60 * 60 * 4 * 1000,
  baseURL,
  headers: {
    Accept: 'application/json, text/javascript, */*; q=0.01',
    'Content-Type': 'application/json'
  },
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
  withXSRFToken: isApiRequest,
  transformRequest: [
    sendFormDataAsMultipart,
    ...([] as AxiosRequestTransformer[]).concat(axios.defaults.transformRequest ?? [])
  ],
  paramsSerializer: (params: Record<string, unknown>) => qs.stringify(params, { indices: false })
}
